import { connect } from 'react-redux';
import SnacksDrinks from './SnacksDrinks.component';
import concessionsModule from 'app/store/concessions';

const { requestConcessionCategories, requestConcessionItem, requestConcessionCombo, setConcessionData } = concessionsModule.actions;
const mapDispatchToProps = {
  setConcessionRequest: requestConcessionCategories,
  setConcessionItemRequest: requestConcessionItem,
  setConcessionComboRequest: requestConcessionCombo,
  setConcessionData
};
const mapStateToProps = ({ }) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(SnacksDrinks);